/**
 * Project Configuration
 *
 * Configurable project prefix read from VITE_PROJECT_PREFIX environment
 * variable, defaulting to "voice-recipe". Used for localStorage keys,
 * resource naming, and display text throughout the application.
 */

export const PROJECT_PREFIX = import.meta.env.VITE_PROJECT_PREFIX || 'voice-recipe';
